<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Adicionar Volume
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-select
            v-model="volumeSelected"
            :items="volumes"
            item-text="name"
            item-value="id"
            label="Selecione um volume"
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onSubmit()"
          >
            Incluir
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
  },
  data: () => ({
    volumes: [],
    volumeSelected: null
  }),

  computed: {
  },

  created () {
    this.getVolumes()
  },
  methods: {

    async getVolumes () {
      try {
        this.volumes = await this.$api.listVolumes()
      } catch (e) {
        // console.log(e)
      }
    },

    onCancel () {
      this.$emit('resolve', false)
    },

    onSubmit () {
      this.$emit('resolve', this.volumeSelected)
    }
  }
}
</script>
